export const custom_category_base_url =
  "https://q2pay.in/new_assets/common/category_icon";

export const CATEGORY_ICON_IMAGES = {
  "payments.svg": `${custom_category_base_url}/payments.svg`,
  "card.svg": `${custom_category_base_url}/card.svg`,
  "savings.svg": `${custom_category_base_url}/savings.svg`,
  "receipt.svg": `${custom_category_base_url}/receipt.svg`,
  "account.svg": `${custom_category_base_url}/account.svg`,
  "subscriptions.svg": `${custom_category_base_url}/subscriptions.svg`,

  "flight.svg": `${custom_category_base_url}/flight.svg`,
  "education.svg": `${custom_category_base_url}/education.svg`,
  "people.svg": `${custom_category_base_url}/people.svg`,
  "event_note.svg": `${custom_category_base_url}/event_note.svg`,
  "inventory.svg": `${custom_category_base_url}/inventory.svg`,
  "hub.svg": `${custom_category_base_url}/hub.svg`,

  "analytics.svg": `${custom_category_base_url}/analytics.svg`,
  "wallet.svg": `${custom_category_base_url}/wallet.svg`,
  "entity.svg": `${custom_category_base_url}/entity.svg`,
  "delivery_truck.svg": `${custom_category_base_url}/delivery_truck.svg`,
  "list.svg": `${custom_category_base_url}/list.svg`,
  "cloud.svg": `${custom_category_base_url}/cloud.svg`,

  "paint.svg": `${custom_category_base_url}/paint.svg`,
  "health_and_safety.svg": `${custom_category_base_url}/health_and_safety.svg`,
  "dining.svg": `${custom_category_base_url}/dining.svg`,
  "construction.svg": `${custom_category_base_url}/construction.svg`,
  "laptop.svg": `${custom_category_base_url}/laptop.svg`,
  "phone.svg": `${custom_category_base_url}/phone.svg`,

  "default.svg": `${custom_category_base_url}/default.svg`,
  "near_me.svg": `${custom_category_base_url}/near_me.svg`,
  "liquor.svg": `${custom_category_base_url}/liquor.svg`,
  "gas.svg": `${custom_category_base_url}/gas.svg`,
  "flights_and_hotels.svg": `${custom_category_base_url}/flights_and_hotels.svg`,
  "spa.svg": `${custom_category_base_url}/spa.svg`,

  "sports.svg": `${custom_category_base_url}/sports.svg`,
  "home.svg": `${custom_category_base_url}/home.svg`,
  "store.svg": `${custom_category_base_url}/store.svg`,
  "trolley.svg": `${custom_category_base_url}/trolley.svg`,
  "movie.svg": `${custom_category_base_url}/movie.svg`,
  "train.svg": `${custom_category_base_url}/train.svg`,

  "science.svg": `${custom_category_base_url}/science.svg`,
  "network.svg": `${custom_category_base_url}/network.svg`,
  "security.svg": `${custom_category_base_url}/security.svg`,
  "fitness.svg": `${custom_category_base_url}/fitness.svg`,
  "tools.svg": `${custom_category_base_url}/tools.svg`,
  "tv.svg": `${custom_category_base_url}/tv.svg`,

  "car.svg": `${custom_category_base_url}/car.svg`,
  "package.svg": `${custom_category_base_url}/package.svg`,
  "leaf.svg": `${custom_category_base_url}/leaf.svg`,
  "attach.svg": `${custom_category_base_url}/attach.svg`,
  "accessory.svg": `${custom_category_base_url}/accessory.svg`,
  "clean.svg": `${custom_category_base_url}/clean.svg`,

  "tag.svg": `${custom_category_base_url}/tag.svg`,
  "stationery.svg": `${custom_category_base_url}/stationery.svg`,
};
